import React from "react";
import { useOne } from "@refinedev/core";
import { Box, SkeletonText, Text } from "@chakra-ui/react";

interface TextFieldProps {
  source: string;
  label?: string;
  value: string;
  displayField?: string;
  fontSize?: string;
  fontWeight?: string;
  labelSize?: string;
  labelWeight?: string;
}

export const TextField: React.FC<TextFieldProps> = ({
  source,
  label,
  value = "",
  displayField = "name",
  fontSize = "14px",
  fontWeight = "light",
  labelSize = "12px",
  labelWeight = "bold",
}) => {
  const { data, isLoading, isError } = useOne({
    resource: source,
    id: value,
  });

  const displayValue = (data: any) => {
    const responseData = data.data;
    if (responseData && displayField in responseData) {
      return responseData[displayField];
    } else {
      return "Not found";
    }
  };

  return (
    <Box>
      {label && (
        <Text fontSize={labelSize} fontWeight={labelWeight}>
          {label}
        </Text>
      )}
      {!isLoading && data ? (
        <Text fontSize={fontSize} fontWeight={fontWeight}>
          {displayValue(data)}
        </Text>
      ) : (
        <SkeletonText noOfLines={1} skeletonHeight="2" />
      )}
    </Box>
  );
};
